import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './Checkout';

const CheckoutSuspense = dynamic(() => import('./Checkout'), {
	loading: () => <BlockLoadingSpinner />,
});

export default function DynamicCheckout(props: Props) {
	return <CheckoutSuspense {...props} />;
}
DynamicCheckout.displayName = 'DynamicCheckout';
